import { IConfig, ForloebClient } from '../../../api';

const forloebClient = new ForloebClient(new IConfig());

export const fetchCourse = (id: string) => {	
	return forloebClient.byId(id);
};
